<template>
  <div class="paypal-direct-checkbox">
    <div
      class="select-text"
      :class="{ active: paypalAgreement }"
      @click="toggleSavePayway"
    >
      {{ language.useDirectPay }}
    </div>
    <div class="small-tips">{{ language.paypalFraudnetInfo }}</div>
  </div>
</template>

<script>
import { TOGGLE_PAYPAL_AGREEMENT } from '@store/officialTopupNew';
export default {
  props: ['language'],
  name: 'PaypalDirect',
  computed: {
    paypalAgreement() {
      return this.$store.state.paypalAgreement;
    }
  },
  methods: {
    toggleSavePayway() {
      this.$store.commit(TOGGLE_PAYPAL_AGREEMENT);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/_dimen.scss';

.paypal-direct-checkbox {
  width: 100%;
  padding: 15px 20px;
  border: 1px solid #b9c4c9;
  border-radius: 9px;
  box-sizing: border-box;
  .small-tips {
    font-size: 22px;
    margin-top: 10px;
    margin-left: 30px;
    color: #999999;
  }
  .select-text {
    display: inline-block;
    cursor: pointer;
    color: $themeColor;
    font-size: 26px;
    font-weight: 400;
    line-height: 20px;
    padding-left: 30px;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    &::before {
      content: '';
      border-color: transparent #fff #fff transparent;
      border-radius: 0 2px 1px;
      border-style: solid;
      border-width: 1px 3px 3px 1px;
      height: 15px;
      width: 9px;
      position: absolute;
      top: 3px;
      left: 1px;
      opacity: 0;
      transform: rotate(37deg);
      transform-origin: 100% 100%;
      transition: opacity 0.2s ease-out;
      z-index: 1;
      box-sizing: border-box;
    }
    &::after {
      content: '';
      background-color: #fff;
      border: 1px solid #b9c4c9;
      border-radius: 3px;
      height: 20px;
      width: 20px;
      position: absolute;
      left: 0;
      top: 0;
      transition: background 0.15s ease-out, border 0.05s ease-out,
        box-shadow 0.1s ease-out;
      z-index: 0;
    }
    &.active {
      &::before {
        opacity: 1;
      }
      &::after {
        background-color: $themeColor;
        border-color: $themeColor;
        box-shadow: 0 0 0 1px $themeColor;
      }
    }
    &:hover {
      &::after {
        border-color: $themeColor;
        box-shadow: 0 0 0 2px $themeColor;
      }
    }
  }
}
#ssr-page.landscape {
  .paypal-direct-checkbox {
    .small-tips {
      font-size: 16px;
    }
    .select-text {
      font-size: 18px;
    }
  }
}
</style>
